module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"invaild_image":"extension is not supported.","post":"Post"}}')
  delete Component.options._Ctor
}
